import { readApiBase, type ReadApiBaseOptions } from "./api-config";

/**
 * 静态资源与上传目录（/uploads）所在站点根。
 * 开发时常为「页面 :5173 + API :8082」：应以后端 origin 拼 /uploads。
 */
export function readAppOrigin(apiBaseOptions?: ReadApiBaseOptions): string {
  try {
    if (typeof window !== "undefined" && window.location?.origin) {
      const api = readApiBase(apiBaseOptions).replace(/\/+$/, "");
      try {
        const baseForParse = /^https?:\/\//i.test(api)
          ? api
          : `${window.location.origin}${api.startsWith("/") ? "" : "/"}${api}`;
        const apiOrigin = new URL(baseForParse).origin;
        if (apiOrigin !== window.location.origin) {
          return apiOrigin;
        }
      } catch {
        /* 回退为当前页 origin */
      }
      return window.location.origin;
    }
  } catch {
    /* ignore */
  }
  const api = readApiBase(apiBaseOptions).replace(/\/+$/, "");
  return api.replace(/\/api$/i, "") || api;
}
